import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function animateAnchor() {
  // Ne pas afficher sur la page /contact
  if (window.location.pathname !== "/contact") {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "body",
        start: "top+=600 top",
        toggleActions: "play reverse play reverse"
      }
    });

    tl.set("#is-contact-anchor", {
      opacity: 0,
      scale: 0.2,
      transformOrigin: "center"
    });

    tl.to("#is-contact-anchor", {
      opacity: 1,
      scaleY: 1.4,
      scaleX: 0.6,
      duration: 0.3,
      ease: "power2.out"
    });

    tl.to("#is-contact-anchor", {
      scaleY: 0.7,
      scaleX: 1.2,
      duration: 0.2,
      ease: "power1.inOut"
    });

    tl.to("#is-contact-anchor", {
      scaleY: 1,
      scaleX: 1,
      duration: 0.4,
      ease: "elastic.out(1, 0.4)",
      onComplete: () => {
        // 🫧 Lancement de la pulsation douce
        gsap.to("#is-contact-anchor", {
          scale: 1.03,
          duration: 1.5,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true
        });
      }
    });
  }

}
